
import { defineComponent, toRefs, reactive } from "vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

export default defineComponent({
  name: "ExternalPage",
  components: {
    LoadingSpinner,
  },
  setup() {
    const state = reactive({
      iframeLoaded: false,
    });

    const onIframeLoad = () => {
      state.iframeLoaded = true;
    };

    return {
      ...toRefs(state),
      onIframeLoad,
    };
  },
});
